/**
 * @desc inDeliveryWriteBack
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.InDeliverySendBackRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/Batch/refund`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
